import { EColumnType } from "../table/EColumnType";
import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { EImportacaoType } from "../table/EImportacaoType";
import { ITableProps } from "../table/ITableProps";
import { HttpParams } from "@angular/common/http";

@Component({
  selector: "ngx-status-importacao-erro",
  templateUrl: "./status-erro.component.html",
  styleUrls: ["./status-erro.component.scss"],
})
export class StatusErroComponent implements OnInit {
  @Input() importacaoType: EImportacaoType;
  @Input() columns: Array<ITableProps>;
  @Input() urlGet: string;
  @Input() filters: HttpParams;
  @Input() showActionButtons: boolean;

  @Output() downloadErrorReport: EventEmitter<void> = new EventEmitter<void>();
  @Output() continue: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  public customLogin = null;
  public EColumnType = EColumnType;

  ngOnInit() {
    let resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);
  }

  onDownloadErrorReport() {
    this.downloadErrorReport.emit();
  }

  onContinue() {
    this.continue.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }
}
